/** 관리자 정렬 옵션
 * - N개씩 정렬
 */
export const ADMIN_SORT_OPTIONS: { value: number; label: string }[] = [
  { value: 10, label: '10개씩 정렬' },
  { value: 50, label: '50개씩 정렬' },
  { value: 100, label: '100개씩 정렬' },
  { value: 200, label: '200개씩 정렬' },
  { value: 500, label: '500개씩 정렬' },
];

/** 관리자 게시물 정렬 옵션
 * - 정렬순, 최신순, 인기순
 */
export const ADMIN_SORT_ORDER_OPTIONS = [
  { value: 'order:ASC', label: '정렬순' },
  { value: 'created_at:DESC', label: '최신순' },
  { value: 'count:DESC', label: '인기순' },
];

export const ADMIN_USER_GROUP = [
  { id: 5, value: 5, label: '일반회원' },
  { id: 2, value: 2, label: '메인관리자' },
];

export const ADMIN_USER_GROUP_FOR_ROOT = [
  { id: 5, value: 5, label: '일반회원' },
  { id: 2, value: 2, label: '메인관리자' },
  { id: 1, value: 1, label: '최고관리자' },
];

/** 관리자 게시글 게시 상태
 * - 미등록, 등록
 */
export const ADMIN_BC_STATUS_OPTIONS = [
  { id: 1, value: 1, label: '미등록' },
  { id: 2, value: 2, label: '등록' },
];

/** 사용자 게시글 게시 상태
 * - 공개, 비공개
 */
export const BC_STATUS_OPTIONS = [
  { value: '2', label: '공개' },
  { value: '1', label: '비공개' },
];

/** 관리자 문의 게시글 게시 상태
 * - 답변대기, 답변완료
 */
export const ADMIN_BC_INQUIRY_STATUS_OPTIONS = [
  { value: 3, label: '답변대기' },
  { value: 4, label: '답변완료' },
];

/** 관리자 게시글 타입
 * - 공지, 일반
 */
export const ADMIN_BC_TYPE_OPTIONS = [
  { value: 1, label: '공지' },
  { value: 2, label: '일반' },
];

/** 관리자 게시물 외부링크
 * - 미사용, 사용
 */
export const ADMIN_BC_LINK_STATUS_RADIO = [
  { id: '0', value: '0', label: '미사용' },
  { id: '1', value: '1', label: '사용' },
];

/** 관리자 게시판 설정 게시판 상태
 * - 미사용, 사용
 */
export const ADMIN_BD_STATUS = [
  { value: 1, label: '미사용' },
  { value: 2, label: '사용' },
];

/** 관리자 게시판 설정 레이아웃
 * - 일반, 갤러리, 문의
 */
export const ADMIN_BD_LAYOUT = [
  { value: 'news', label: '뉴스 게시판' },
  { value: 'inquiry', label: '문의 게시판' },
  { value: 'faq', label: 'FAQ' },
];

/** 관리자 게시판 설정 게시물 초기 상태
 * - 미등록, 등록, 답변대기, 답변완료
 */
export const ADMIN_BD_INITIAL_BC_STATUS = [
  { value: 1, label: '미등록' },
  { value: 2, label: '등록' },
  { value: 3, label: '답변대기' },
  { value: 4, label: '답변완료' },
];

/** 관리자 게시판 옵션 설정 사용 여부
 * - 카테고리, 태그, 댓글, 관리자 댓글 수정/삭제, 이메일 알림 기능 사용 여부
 * - 미사용, 사용
 */
export const ADMIN_BD_OPTIONS_STATUS = [
  { id: '0', value: '0', label: '미사용' },
  { id: '1', value: '1', label: '사용' },
];

/** 관리자 게시판 권한 설정 회원 그룹
 * - 일반회원, 메인관리자, 최고관리자
 * - TODO: API 연동
 */
export const ADMIN_BD_AUTH_USER_GROUP = [
  { id: 'basic', value: 'basic', label: '일반회원' },
  { id: 'admin', value: 'admin', label: '메인관리자' },
  { id: 'root', value: 'root', label: '최고관리자' },
];

/** 사용자 게시물 공개 설정
 * - 전체 공개, 비밀글
 * - 게시글 타입) 1: 공지사항, 2: 일반글, 3: 비밀글(미사용), 4: 외부링크
 */
export const USER_BC_TYPE_RADIO = [
  { id: '2', value: 2, label: '전체 공개' }, // 전체 공개가 일반글과 같음
  { id: '1', value: 3, label: '비밀글' },
];

/**
 * TODO : 백엔드 댓글 허용여부 관련 처리 후 수정 필요
 * 사용자 게시물 댓글 허용
 * - 허용, 허용 안함
 */
export const USER_BC_REPLY_RADIO = [
  { id: '1', value: 1, label: '허용' },
  { id: '0', value: 0, label: '허용 안함' },
];

export const ADMIN_DEFAULT_SORT_COUNT = 10;
export const USER_DEFAULT_SORT_COUNT = 10;

// 원청징수 세액
export const WITHHOLDING_TAX = 3.3;

// 클라이언트
export const CLIENT_ACCOUNT_INFO = '농협 333-1999-232323';
export const CLIENT_COMPANY_INFO = '(주) 살만';

/** 자주 묻는 질문 */
export const FAQ_URL =
  'https://salmaninc.notion.site/3e2d77c5688d4d3981f6cd215643a1f7?pvs=4';

// 채널톡 추소
export const CHANNEL_TALK_URL = 'https://18l9l.channel.io/home';

export const GENDER = {
  '0': '여성',
  '1': '남성',
};

// SVG 아이콘 사이즈에 따른 strokeWidth 값 정의
export const SVG_STOROKE_SIZE = {
  12: 1,
  16: 1.5,
  20: 1.5,
  24: 2,
  28: 2,
  32: 2,
  36: 2,
};
